import React from "react"
import { Container, Grid, Button } from "semantic-ui-react"
import { Link } from "react-router-dom"
import "./Overview.css"

export class OverviewDirectPaid extends React.Component {
  render = () => {
    const { nextUrl, plan } = this.props
    return (
      <Container textAlign="center" className="white">
        <Grid centered stackable className="overview_maindiv">
          <Grid.Row style={{ paddingBottom: "0px" }}>
            <Grid.Column textAlign="center">
              <h2 className="overview__Heading">Woo hoo!</h2>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingTop: "0px" }}>
            <Grid.Column
              className="overview__Description"
              width={14}
              textAlign="center"
            >
              <p className="overview__DescriptionText">
                You’re <i>almost</i> a financial action hero! Just a few more
                steps and you’ll be ready to fly with SAVVI.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered columns={2}>
            <Grid.Column width={6}>
              <div className="overview_title">
                You’ve chosen our {plan.name} plan!
              </div>
              <p>
                You’ve chosen our {plan.name} plan. Excellent choice.{" "}
                {plan.free_trial_days
                  ? `You'll have a ${plan.free_trial_days} free trial (credit card required), then for`
                  : " For"}{" "}
                less than {Math.ceil((100 * plan.amount * 12) / 365)} cents a
                day (even less if it’s a leap year!) you can be more confident
                about your money. You clearly see the value of quality financial
                advice and with this version you get all of the awesome
                capabilities of the tool: organizing your accounts, setting
                goals and getting actionable advice. Yes!
              </p>
            </Grid.Column>
            <Grid.Column>
              <div className="overview_title">A few more things to know</div>
              <ul className="overview__List">
                <li>
                  The advice you’re going to get… it’s personalized and
                  independent. We put your best interests first. Great, right?
                </li>
                <li>
                  We protect your data with layers of security. SAVVI cares
                  about data privacy and security and has a SOC 2 Type II
                  Certification to prove it.
                </li>
                <li>
                  The agreements you’re about to see acknowledge our promises to
                  you. It’s stronger than a pinky swear and written by lawyers.
                </li>
              </ul>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <div className="overview_details">
                <p>Ready? Okay… Review. Accept. Go!</p>
                <br />
                <Link to={nextUrl} className="navlink">
                  <Button
                    primary
                    size="big"
                    className="overview_Button"
                    data-testid="continue"
                  >
                    Continue
                  </Button>
                </Link>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }
}
